import BlogService from '../../services/blog.service'

const initialState = {
    status: {
        success: false,
    },
    posts: null
}

export const blog = {
    namespaced: true,
    state: initialState,
    actions: {
        GET_POSTS({ commit }) {
            return BlogService.getPosts().then(
                response => {
                    commit('POST_SUCCESS', response.data.data.data);
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('FAILURE');
                    return Promise.reject(error);
                }
            );
        },
        GET_POSTS_BY_CATEGORIES({ commit }, slug) {
            return BlogService.getPostsByCategories(slug).then(
                response => {
                    commit('SUCCESS');
                    return Promise.resolve(response.data.data)
                }, error => {
                    commit('FAILURE');
                    return Promise.reject(error);
                }
            )
        },
        GET_SINGLE_POST({ commit }, slug) {
            return BlogService.getSinglePost(slug).then(
                response => {
                    commit('SUCCESS');
                    return Promise.resolve(response.data)
                }, error => {
                    commit('FAILURE');
                    return Promise.reject(error);
                }
            )
        }
    },
    mutations: {
        POST_SUCCESS(state, data) {
            state.status.success = true
            state.posts - data
        },
        SUCCESS(state) {
            state.status.success = true
        },
        FAILURE(state) {
            state.status.success = false
        }
    },
    getters: {
        posts: state => {
            return state.posts
        }
    }
};
